import { getSiteRolloutStatus } from '@wix/ambassador-bookings-v1-site-rollout-status/http';
export const isBookingsOnEcom = async (request, { httpClient }) => {
    try {
        const { data: siteRolloutStatusResponse } = await httpClient.request(getSiteRolloutStatus(request));
        return siteRolloutStatusResponse.siteRolloutStatus.isBookingPlatformReady;
    }
    catch (_a) { }
    return false;
};
//# sourceMappingURL=isBookingsOnEcom.js.map